import { FilterFieldConfig } from "types/FilterFieldConfig";
import { CATEGORY_OPTIONS } from "./category.constants";
export const buildTrainerPackageFilterFields = (
  categoryOptions: { label: string; value: string }[],
): FilterFieldConfig<{
  search: string;
  verified_package: boolean | undefined;
  category: string;
  is_active: string;
}>[] => {
  return [
    {
      key: "category",
      label: "Category",
      type: "select",
      options: CATEGORY_OPTIONS.map((option) => ({
        label: option.label,
        value: option.value,
      })),
      placeholder: "All categories",
    },
    {
      key: "verified_package",
      label: "Verified",
      type: "boolean",
    },
    {
      key: "is_active",
      label: "Status",
      type: "select",
      options: [
        { label: "Active", value: "true" },
        { label: "Inactive", value: "false" },
      ],
    },
  ];
};
